import React, { useEffect, useState } from 'react'
import useReport from '../useReport'
import { Bar } from 'react-chartjs-2';
import Modal from 'react-modal';
import PieChartModal from './MonthDetailModal';
import MonthDetailModal from './MonthDetailModal';

const customStylesOrderDetail = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)', // This sets the overlay color
    zIndex: 1000
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: '1000px',
    width: '1900px',
    marginRight: '0%',
    transform: 'translate(-50%, -50%)',
  },
};

const RegisMonthSummaryReport = () => {
  const { reportData = [], isLoading, getRegisMonthAmountReport, getRegisMonthAmountDetail } = useReport();
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [orderMonth, setOrderMonth] = useState(null);
  const [registerMonth, setRegisterMonth] = useState(null);

  useEffect(() => {
    getRegisMonthAmountReport();
  }, []);

  const openModal = async (month, registerMonth) => {
    setShowModal(true);
    try {
      // Fetch the modal data based on the clicked bar
      const detailData = await getRegisMonthAmountDetail({ month, registerMonth });
      setModalData(detailData);
    } catch (error) {
      console.error('Error fetching modal data:', error);
      setModalData(null);
    }
  };
  
  const closeModal = () => {
    setShowModal(false);
    setModalData(null);
  };

  useEffect(() => {
    console.log(modalData)
  },[modalData])

  const handleBarClick = (evt, elements) => {
    if (!elements.length) return;
    // Get the dataset index and data index of the clicked bar
    const { datasetIndex, index } = elements[0];
    const clickedRegisterMonth = chartData.datasets[datasetIndex]?.label;
    const clickedOrderMonth = chartData.labels[index];
    setOrderMonth(clickedOrderMonth)
    setRegisterMonth(clickedRegisterMonth)

    if (clickedOrderMonth && clickedRegisterMonth) {
      // Convert clickedOrderMonth and clickedRegisterMonth to YYYY-MM-DD format
      const orderDate = new Date(`01 ${clickedOrderMonth} UTC`); // Treat as UTC to avoid timezone shifts
      orderDate.setDate(orderDate.getDate() + 1); // Add 1 day
      const formattedOrderMonth = orderDate.toISOString().slice(0, 10); // Convert to YYYY-MM-DD
  
      const registerDate = new Date(`01 ${clickedRegisterMonth} UTC`);
      registerDate.setDate(registerDate.getDate() + 1); // Add 1 day
      const formattedRegisterMonth = registerDate.toISOString().slice(0, 10); // Convert to YYYY-MM-DD
  
      openModal(formattedOrderMonth, formattedRegisterMonth); // Pass reformatted dates
    }
  };

  useEffect(() => {
    if (reportData.length > 0) {

      // Group data by orderMonth and registerMonth
      const aggregatedData = reportData.reduce((acc, { orderMonth, totalAmount, registerMonth }) => {
        const month = new Date(orderMonth).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
        const regMonth = new Date(registerMonth).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });

        if (!acc[month]) {
          acc[month] = {};
        }
        if (!acc[month][regMonth]) {
          acc[month][regMonth] = 0;
        }
        acc[month][regMonth] += totalAmount;

        return acc;
      }, {});

      // Prepare data for the chart
      const labels = Object.keys(aggregatedData);

      const registerMonths = Array.from(new Set(
        Object.values(aggregatedData).flatMap(monthData => Object.keys(monthData))
      )).sort((a, b) => new Date(a) - new Date(b));

      const datasets = registerMonths.map((regMonth, index) => ({
        label: regMonth,
        data: labels.map(month => aggregatedData[month][regMonth] || 0),
        backgroundColor: `rgba(${index * 50 % 255}, ${index * 70 % 255}, ${index * 100 % 255}, 0.6)`,
        borderColor: `rgba(${index * 50 % 255}, ${index * 70 % 255}, ${index * 100 % 255}, 1)`,
        borderWidth: 1,
      }));
      console.log(aggregatedData)
      console.log(labels)
      setChartData({
        labels,
        datasets,
        aggregatedData
      });
    }
  }, [reportData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || '';
            const value = context.raw;
            let totalForMonth = 0;
            chartData.datasets.forEach(dataset => {
              totalForMonth += dataset.data[context.dataIndex] || 0;
            });
            const percentage = ((value / totalForMonth) * 100).toFixed(2);
            return `${label}: ${Math.round(value / 10000, 2) / 100} M (${percentage}%)`;
          },
        },
        bodyFont: {
          size: 16
        },
        titleFont: {
          size: 16
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          font: {
            size: 16
          }
        }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          font: {
            size: 14
          }
        }
      },
    },
    onClick: handleBarClick
  };


  if (isLoading) return <div>Loading report...</div>;

  return (
    <div style={{ width: '65%', height: '800px'}}>
      <Modal
        isOpen={showModal}
        onRequestClose={closeModal}
        style={customStylesOrderDetail}
        ariaHideApp={false}
      >
        <MonthDetailModal
          data={modalData}
          month={orderMonth}
          registerMonth={registerMonth}
        />
      </Modal>
      <div style={{ height: '100%' }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
}

export default RegisMonthSummaryReport